{
  "de": {
    "headlines": {
      "admin": {
        "dashboard": {
          "title": "Dashboard",
          "modelsByClassification": "Modelle nach Klassifizierung",
          "models": "Neu geladene Modelle",
          "modelsByManufacturer": "Modelle nach Hersteller",
          "manufacturers": "Hersteller",
          "modelsByStatus": "Modelle nach Status",
          "modelsBySize": "Modelle nach Größe",
          "modelsPerMonth": "Modelle pro Monat",
          "componentsByClass": "Komponenten nach Klasse",
          "components": "Komponenten",
          "visitsPerDay": "Besuche pro Tag",
          "visitsPerMonth": "Besuche pro Monat",
          "mostViewedPages": "Meistbesuchte Seiten",
          "registrationsPerMonth": "Registrierungen pro Monat",
          "users": "Benutzer"
        },
        "models": {
          "index": "Modelle",
          "edit": {
            "index": "Modell bearbeiten",
            "fleetchart": "Flottenkarten-Bilder",
            "hardpoints": "Aufhängungspunkte",
            "cargoAndFuel": "Fracht & Treibstoff",
            "cargoHolds": "Frachträume",
            "metrics": "Metriken",
            "prices": "Preise",
            "docks": "Andockplätze",
            "modules": "Module",
            "paints": "Lackierungen",
            "videos": "Videos",
            "images": "Bilder",
            "itemPrices": "Artikelpreise",
            "linkModule": "Vorhandenes Modul verknüpfen",
            "loaners": "Leihschiffe",
            "upgrades": "Upgrades",
            "packages": "Pakete",
            "linkUpgrade": "Vorhandenes Upgrade verknüpfen"
          },
          "new": "Neues Modell",
          "show": "Modell",
          "images": "Bilder",
          "tableConfigurationModal": "Tabellenkonfiguration"
        },
        "components": {
          "index": "Komponenten",
          "new": "Neue Komponente",
          "edit": {
            "index": "Komponente bearbeiten",
            "itemPrices": "Artikelpreise"
          }
        },
        "modelPaints": {
          "index": "Lackierungen",
          "new": "Neue Lackierung",
          "edit": "Lackierung bearbeiten"
        },
        "modelModules": {
          "index": "Module",
          "new": "Neues Modul",
          "edit": "Modul bearbeiten",
          "models": "Verknüpfte Modelle",
          "prices": "Preise"
        },
        "manufacturers": {
          "index": "Hersteller",
          "new": "Neuer Hersteller",
          "edit": "Hersteller bearbeiten"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Benutzer bearbeiten",
          "fleets": "Flotten"
        },
        "vehicles": {
          "index": "Fahrzeuge",
          "edit": "Fahrzeug bearbeiten"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Flotte bearbeiten",
          "memberEdit": "Mitglied bearbeiten"
        },
        "admins": {
          "index": "Administratoren",
          "new": "Neuer Administrator",
          "edit": "Administrator bearbeiten"
        },
        "oauthApplications": {
          "index": "OAuth-Anwendungen",
          "new": "Neue OAuth-Anwendung",
          "edit": "OAuth-Anwendung bearbeiten"
        },
        "features": {
          "index": "Feature-Flags",
          "show": "Funktionsdetails",
          "globalState": "Globaler Status",
          "groups": "Gruppen",
          "actors": "Akteure",
          "selfService": "Self-Service",
          "percentageOfActors": "Prozent der Akteure",
          "percentageOfTime": "Prozent der Zeit",
          "addActor": "Akteur hinzufügen"
        },
        "rsiApiStatus": {
          "index": "RSI-API-Status"
        },
        "images": {
          "index": "Bilder"
        },
        "imports": {
          "index": "Importe"
        }
      },
      "welcome": "Willkommen auf",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "Schiffe Flottenübersicht"
      },
      "images": "Images Index",
      "stats": "Statistiken",
      "notFound": "Navigationsfehler",
      "featureNotReady": "Demnächst",
      "accessDenied": "Zugriff verweigert",
      "serverError": "Serverfehler",
      "comments": "Kommentare",
      "login": "Anmelden",
      "hangar": {
        "index": "Mein Hangar",
        "preview": {
          "h1": "Mein Hangar Vorschau",
          "h2": "Your personal Hangar requires an FleetYards.net Account",
          "h3": "What Features does the Hangar include?"
        },
        "alternativeNames": "Alternative Namen",
        "stats": "Statistiken",
        "public": "%{user} Hangar",
        "import": "Importieren",
        "wishlist": "Wunschliste",
        "publicStats": "Statistiken",
        "publicWishlist": "%{user} Wunschliste",
        "resetIngame": "Ingame-Schiffe nach Wipe zurücksetzen"
      },
      "syncExtension": "RSI-Hangar synchronisieren",
      "editMyVehicle": "Edit my %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "Impressum",
      "privacy": "Datenschutzerklärung",
      "cookie": "Cookie policy",
      "requestPassword": "Passwort anfordern",
      "changePassword": "Passwort ändern",
      "confirmAccess": "Confirm access",
      "setEmail": "E-Mail-Adresse festlegen",
      "oauthAuthorize": "Anwendung autorisieren",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "Flotteneinladungen",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "Mitglieder-Weltkarte",
          "starmap": "Mitglieder-Sternenkarte"
        },
        "stats": "Statistiken",
        "logistics": {
          "index": "Logistics",
          "inventories": "Inventories",
          "requests": "Requests",
          "newRequest": "New Request",
          "requestItems": "Items",
          "comments": "Comments",
          "createInventory": "Create Inventory",
          "createItem": "Add Item",
          "importCsv": "Import from CSV"
        },
        "preview": {
          "h1": "Flottenvorschau",
          "h2": "To create a Fleet you need to have a FleetYards.net Account",
          "h3": "What Features does your Fleet include?"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "membership": "Membership Settings",
          "roles": "Flottenrollen"
        },
        "inviteMember": "Invite new Member"
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "Schiffe vergleichen"
      },
      "settings": {
        "account": "Konto",
        "profile": "Profileinstellungen",
        "hangar": "Hangar-Einstellungen",
        "features": "Feature-Flags",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Anwendungen",
        "notifications": "Benachrichtigungseinstellungen",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "Kontosicherheit",
          "twoFactor": "Two-factor Authentiation"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentiation",
          "disable": "Disable Two-factor Authentiation",
          "backupCodes": "Generate Two-Factor Backup Codes"
        }
      },
      "oauthApplications": {
        "new": "Neue OAuth-Anwendung",
        "edit": "OAuth-Anwendung bearbeiten"
      },
      "roadmap": "Schiff-Roadmap",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtraster",
        "profitCalculator": {
          "index": "Profit Calculator"
        },
        "tradeRoutes": {
          "index": "Trade Routes",
          "withShip": "Trade Routes for %{name} (%{cargo})"
        }
      },
      "rsiVerification": "Verify your RSI-Account",
      "hangarGuideEmpty": "Not much to see here?",
      "hangarGuide": "Hangar Guide",
      "support": "Support FleetYards.net",
      "supportHint": {
        "hangarSync": "Schön, dass dir der Sync hilft",
        "vehicleAdded": "Dein Hangar wächst",
        "fleetCreated": "Neue Flotte — gratuliere!",
        "loginMilestone": "Schön, dass du wieder da bist",
        "visitMilestone": "Gefällt dir FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Gruppen hinzufügen/entfernen"
      },
      "pagination": {
        "count": "%{current} von %{total}"
      },
      "models": {
        "index": "Modelle"
      },
      "modals": {
        "models": {
          "displayOptions": "Anzeigeoptionen"
        },
        "shopCommodity": {
          "update": "Update Commodity %{shopCommodity}",
          "create": "Add Commodity",
          "sellPrices": "%{shopCommodity} Sell Prices",
          "buyPrices": "%{shopCommodity} Buy Prices",
          "rentalPrices": "%{shopCommodity} Rental Prices"
        },
        "commodityPrice": {
          "create": "Submit Price"
        }
      },
      "visualTests": {
        "overview": "Übersicht",
        "panels": "Bereiche",
        "buttons": "Schaltflächen",
        "tables": "Tabellen",
        "notifications": "Benachrichtigungen",
        "syncModal": "Sync-Modal",
        "supportHint": "Support-Hinweis"
      },
      "filterCargoRoutes": "Filter Cargo routes",
      "filterCommodities": "Filter Commodities",
      "starsystems": "Starsystems",
      "starsystem": "%{starsystem} Starsystem",
      "celestialObjects": "Celestial Objects",
      "celestialObject": "%{celestialObject} in the %{starsystem} System",
      "moons": "Moons",
      "stations": "Stations",
      "station": "%{station} near %{celestialObject}",
      "stationImages": "Images of %{station} near %{celestialObject}",
      "shops": "Shops",
      "shop": "%{shop} on %{station}",
      "commodities": "Commodities"
    }
  }
}
